import { m } from "framer-motion";
import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

export default function Badge({
  badgeContent = 0,
  className,
  children,
  ...props
}: ComponentProps<"div"> & {
  badgeContent?: number;
}) {
  return (
    <div
      className="relative flex h-full items-center"
      data-testid="badge-content-number"
      {...props}
    >
      {badgeContent > 0 && (
        <span
          className={cn(
            "flex-center absolute top-0 right-0 flex h-4 min-w-4 translate-x-1/2 -translate-y-1/2 px-1 text-center text-xs leading-none text-white tabular-nums",
            className,
          )}
        >
          <m.span
            key={badgeContent}
            className="absolute inset-0 block rounded-full bg-black"
            animate={{ scale: [1, 1.2, 0.9, 1] }}
            transition={{
              duration: 1.3,
              times: [0, 0.4, 0.75, 1],
              ease: [0.25, 0.1, 0.25, 1],
            }}
          />
          <span className="all-small-caps z-10 pb-0.5 font-[system-ui] text-sm leading-none font-normal tracking-tighter">
            {badgeContent}
          </span>
        </span>
      )}
      {children}
    </div>
  );
}
